'use strict';

export function isBundleModeEnabled() {
  return false;
}
//# sourceMappingURL=bundleMode.js.map